export const scrollToTop = () => {
  // On mobile widths .layout__content is normally the scroll container, but in
  // the short-viewport reflow mode (400% browser zoom) it goes static and the
  // window scrolls instead — reset both; whichever isn't scrolling is a no-op.
  const content = document.getElementsByClassName('layout__content')
  if (content[0]) {
    content[0].scrollTop = 0
  }
  window.scrollTo(0, 0)
}

export const scrollToBottom = () => {
  const clientWidth = document.documentElement.clientWidth
  if (clientWidth < 992) {
    const content = document.getElementsByClassName('layout__content')
    if (content[0]) {
      content[0].scrollTop = content[0].scrollHeight
    }
  } else {
    window.scrollTo(0, document.body.scrollHeight)
  }
}
